<template>
  <div class="game-footer">
    <div class="game-back-btn" @click="onBack">
      <i class="bi bi-chevron-left"></i>
      <img src="https://res.megalake.games/lobby/logo.png" class="button" alt="" />
      <!-- <img src="https://s3.1onebet.com/ui/logo.png" class="logo" alt="" /> -->
    </div>
    <!-- <div class="button-group">
      <div class="middle" @click="onBack">{{ $t('button.returnback') }}</div>
      <div class="right" @click="onClick">{{ $t('navBar.deposit') }}</div>
    </div> -->
    <div class="right flex row center" :key="userBarKey" ref="balanceRef">
      <!-- <div
        class="wallet flex row center"
        style="z-index: 99"
        v-if="currentGameIsBonus == null ? getLocalStorage(bonusKey) == 'true' : currentGameIsBonus"
      >
        <div class="balance">{{ formatMoney(balance.bonus) }} {{ $t('bonus.title') }}</div>
      </div> -->
      <div class="wallet flex row center" style="z-index: 13">
        <div class="balance" @click="showBalanceInfo">
          {{ formatMoney(balance.total) }} {{ balance.currencyAlias }}
        </div>
        <div class="slicer"></div>
        <i class="bi-plus-circle" @click="onDeposit"></i>
      </div>
    </div>
    <BalanceTips
      :show="showBalanceTips"
      :balanceWidth="balanceWidth"
      @hide="showBalanceTips = false"
    />
    <!-- <van-overlay :show="showBalanceTips" @click="showBalanceTips = false" :z-index="13">
      <div class="balance-tips" :style="`width:${balanceWidth}px`">
        <p>CASH:</p>
        <p style="color: #ffddac">{{ formatMoney(balance.cash) }} {{ balance.currencyAlias }}</p>
        <p>BONUS:</p>
        <p style="color: #ffddac">
          {{ formatMoney(balance.bonus) }}
        </p>
        <p>VPS:</p>
        <p style="color: #ffddac">{{ Math.floor(balance.bps) }}</p>
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import { config } from '@/common/config'
import { Key, getLocalStorage } from '@/common/localStorage'
import BalanceTips from '@/components/BalanceTipsComponent.vue'
import { BUS } from '@/event/EventCenter'
import { useLobbyStore } from '@/stores/lobby'
import { useUserStore } from '@/stores/user'
import { formatMoney } from '@/utils/helper'
import { mapState } from 'pinia'

export default {
  name: 'DhGameFooter',
  components: {
    BalanceTips
  },
  data() {
    return {
      userBarKey: 0,
      bonusKey: Key.isBonus,
      showBalanceTips: false,
      balanceWidth: 0
    }
  },
  computed: {
    ...mapState(useUserStore, ['balance']),
    ...mapState(useLobbyStore, ['currentGameIsBonus'])
  },
  mounted() {},
  watch: {
    balance(newValue, oldValue) {
      if (newValue.bonus != oldValue.bonus || newValue.total != oldValue.total) {
        console.log('更新游戏底部携带量')
      }
      console.log('更新游戏底部携带量')
    }
  },
  methods: {
    formatMoney,
    getLocalStorage,
    onBack() {
      const iframe = document.getElementById('frame')
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage('RETURN_TAKEWIN', config.selfDevelopedGameDomain)
      }
      this.$router.replace('/')
    },
    onClick() {
      // this.$router.replace('/deposit')
      this.$bus.$emit(BUS.SHOW_DEPOSIT_IN_GAME, true)
    },
    onUpdatePage() {
      // this.$bus.$emit(BUS.UPDATE_GAME)
    },
    onDeposit() {
      this.$bus.$emit(BUS.SHOW_DEPOSIT_IN_GAME, true)
    },
    checkIsBonus() {
      if (this.currentGameIsBonus == null) {
        return getLocalStorage(Key.isBonus) == 'true'
      } else {
        return this.currentGameIsBonus
      }
    },
    showBalanceInfo() {
      this.balanceWidth = this.$refs.balanceRef.clientWidth - 25
      this.showBalanceTips = !this.showBalanceTips
    }
  }
}
</script>
<style lang="scss" scoped>
.game-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 1rem;
  background: rgba(0, 0, 0, 1);
  // border-radius: 38px;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 3000;

  .game-back-btn {
    display: flex;
    width: auto;
    align-items: center;

    // padding-left: 17px;
    .button {
      // width: 0.8rem;
      height: 0.6rem;
      margin-right: 13px;
    }

    .logo {
      width: 0.5rem;
      // height: 63px;
    }

    i {
      font-size: 0.6rem;
    }
  }

  // .button-group {
  //   display: flex;
  //   justify-content: center;
  //   width: auto;
  //   height: 1rem;
  //   align-items: center;
  //   .middle {
  //     line-height: 0.66rem;
  //     text-align: center;
  //     border-radius: 0.33rem;
  //     margin: 0;
  //     float: left;
  //     color: #aa884a;
  //     border: 2px solid #aa884a;
  //     // position: fixed;
  //     width: 1rem;
  //     height: 0.6rem;
  //     z-index: 2;
  //     padding: 0 0.3rem;
  //     font-size: 0.24rem;
  //   }
  //   .right {
  //     color: #fff;
  //     background-color: #aa884a;
  //     border: 2px solid #aa884a;
  //     width: 3rem;
  //     height: 0.6rem;
  //     line-height: 0.66rem;
  //     text-align: center;
  //     border-radius: 0.33rem;
  //     margin: 0.4rem 0.2rem;
  //     font-size: 0.24rem;
  //   }
  // }

  .right {
    font-size: 0.24rem;
    color: #ceb45f;
    margin-right: 0.2rem;

    .wallet {
      height: 0.5rem;
      border-radius: 0.1rem;
      background: linear-gradient(145deg, #ceb45f 5%, #825c2d 70%);
      padding: 0 0.19rem;
      cursor: pointer;

      .balance {
        min-width: 1rem;
        font-size: 0.3rem;
        line-height: 1;
        color: #fff;
      }

      .slicer {
        background: #000;
        height: 100%;
        width: 0.02rem;
        margin: 0 0.2rem;
      }

      i {
        font-size: 0.2rem;
        color: #fff;
      }
    }
  }

  .balance-tips {
    position: absolute;
    top: 0.7rem;
    right: 0.25rem;
    padding: 0 0.2rem;
    background-color: #000;
    border-radius: 0.15rem;

    p {
      font-size: 0.3rem;
      color: #fff;
      line-height: 0.1rem;
    }
  }
}
</style>
